import {DisabledReason, FormValueControl, ValidationError, WithOptionalField} from '@angular/forms/signals';
import {from} from 'rxjs';
import {Component, input, model, signal} from '@angular/core';

@Component({
  selector: 'app-sex-selector',
  imports: [],
  templateUrl: './sex-selector.html',
  styleUrl: './sex-selector.css',
})
export class SexSelector implements FormValueControl<any> {
  options = input<any>([]);
  value = model<any>();
}
